import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBatteryEmpty: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"battery-empty, power"} maskId="square-filled-radius-0-stroke-1-IconBatteryEmpty"><path fillRule="evenodd" clipRule="evenodd" d="M1 5H20V8H23V16H20V19H1V5ZM20 15H22V9H20V15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBatteryEmpty;
